import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Box, Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../contexts/AuthContext";
import { accentText, AuthShell, GoogleMark, OrDivider } from "./marketing/MarketingParts";
import { EmailField, PasswordField } from "./marketing/AuthFields";

function getApiOrigin() {
  try {
    const base = String(window.__AW_RUNTIME_CONFIG__?.apiBaseUrl || "").replace(/\/$/, "");
    return base || window.location.origin;
  } catch {
    return "";
  }
}

export default function Register() {
  const { t } = useTranslation();
  const { register } = useContext(AuthContext);
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await register({ name, email, password });
      nav("/sites");
    } catch (err) {
      setError(err?.response?.data?.message || t("mka_register_err"));
    }
  };

  const onGoogle = () => {
    const origin = getApiOrigin();
    const next = "/sites";
    window.location.href = `${origin}/api/auth/google/start?next=${encodeURIComponent(next)}`;
  };

  return (
    <AuthShell
      title={t("mka_register_title")}
      subtitle={t("mka_register_sub")}
      footer={
        <>
          {t("mka_have_account")}{" "}
          <Box component={Link} to="/login" sx={{ color: accentText, fontWeight: 600 }}>
            {t("mka_login_link")}
          </Box>
        </>
      }
    >
      <Box sx={{ display: "grid", gap: 2 }}>
        <Button onClick={onGoogle} variant="outlined" size="large" fullWidth startIcon={<GoogleMark />}>
          {t("mka_google_register")}
        </Button>
        <OrDivider label={t("mka_or")} />
        <Box aria-live="polite">{error ? <Alert severity="error">{error}</Alert> : null}</Box>
        <Box component="form" onSubmit={onSubmit} sx={{ display: "grid", gap: 2 }}>
          <TextField label={t("mka_name")} value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" fullWidth />
          <EmailField label={t("mka_email")} value={email} onChange={(e) => setEmail(e.target.value)} />
          <PasswordField label={t("mka_password")} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
          <Button type="submit" variant="contained" size="large" fullWidth>
            {t("mka_register_btn")}
          </Button>
        </Box>
      </Box>
    </AuthShell>
  );
}
